import { PaintedScene } from '../PaintedScene';

export const HAMLET_INTERIOR_PHASER_KEY = 'HamletInteriorScene' as const;
export const HAMLET_INTERIOR_MANIFEST_KEY = 's-109-hamlet-interior' as const;

export class HamletInteriorScene extends PaintedScene {
  constructor() {
    super(HAMLET_INTERIOR_PHASER_KEY, HAMLET_INTERIOR_MANIFEST_KEY);
  }
}
